module.exports = __webpack_public_path__ + "img/explosives.fbb8da4e.png";